import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ab-date',
  templateUrl: './ab-date.component.html',
  styleUrls: ['./ab-date.component.scss']
})
export class AbDateComponent implements OnInit {

 @Input() element: any;
  constructor() { }

  ngOnInit(): void {
  }

}
